import { useEffect, useState } from "react";
import PublicPage from "./PublicPage.jsx";
import {
  PACKS,
  CURRENCIES,
  detectCurrency,
  formatPrice,
  formatPerScan,
} from "./packs.js";

export default function PricingPage({ onNavigate, onGetStarted }) {
  const [currency, setCurrency] = useState("usd");

  useEffect(() => {
    setCurrency(detectCurrency());
  }, []);

  return (
    <PublicPage title="Pricing" onNavigate={onNavigate} onGetStarted={onGetStarted}>
      <p className="landing-sub legal-p">
        No subscription, no monthly fee. Buy a scan pack once, use it at
        your own pace — scans never expire. Buy a bigger pack, pay less per
        scan.
      </p>

      <div className="currency-toggle">
        {CURRENCIES.map((c) => (
          <button
            key={c.code}
            type="button"
            className={c.code === currency ? "active" : ""}
            onClick={() => setCurrency(c.code)}
          >
            {c.label}
          </button>
        ))}
      </div>

      <div className="pack-grid">
        {PACKS.map((p) => (
          <div key={p.id} className="pack-card">
            {p.badge && <span className="pack-badge">{p.badge}</span>}
            <strong>{p.label}</strong>
            <span className="pack-credits">{p.scans} scans</span>
            <span className="pack-price">{formatPrice(p, currency)}</span>
            <span className="pack-credits">
              {formatPerScan(p, currency)}/scan
            </span>
          </div>
        ))}
      </div>

      <button className="primary landing-cta" onClick={onGetStarted}>
        Get started <span aria-hidden>→</span>
      </button>

      <section className="legal-section">
        <h2 className="landing-h2 legal-h2">Frequently asked</h2>
        <div className="landing-faq-list">
          <details className="card landing-faq-item">
            <summary className="landing-faq-q">Is there a free trial?</summary>
            <p className="landing-trust-desc">
              Yes — every new account gets one real receipt scan free, no
              card required, and you can preview a scan result before signing
              in at all.
            </p>
          </details>
          <details className="card landing-faq-item">
            <summary className="landing-faq-q">Do scans expire?</summary>
            <p className="landing-trust-desc">
              No. Buy a pack once and use it over weeks or months at whatever
              pace suits your business.
            </p>
          </details>
          <details className="card landing-faq-item">
            <summary className="landing-faq-q">
              What if a scan fails?
            </summary>
            <p className="landing-trust-desc">
              You're only charged for a successful scan — a failed OCR call
              never deducts from your balance.
            </p>
          </details>
          <details className="card landing-faq-item">
            <summary className="landing-faq-q">Can I get a refund?</summary>
            <p className="landing-trust-desc">
              Unused scans are refundable within 14 days of purchase — see
              our{" "}
              <button className="link-btn" onClick={() => onNavigate("refunds")}>
                Refund Policy
              </button>
              .
            </p>
          </details>
        </div>
      </section>
    </PublicPage>
  );
}
